import React, { useMemo } from "react";
import AgendaSlotCell from "./AgendaSlotCell";

const WEEKDAY_LABELS = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

function startOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay(); // 0=Dom, 1=Seg, ...
  const diff = (day + 6) % 7; // dias atrás até segunda
  d.setDate(d.getDate() - diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

export default function AgendaWeekGrid({ slots, weekStart, onSlotClick }) {
  const days = useMemo(() => {
    return Array.from({ length: 7 }, (_, i) => {
      const d = new Date(weekStart);
      d.setDate(d.getDate() + i);
      return d;
    });
  }, [weekStart]);

  // Agrupa slots por dia (yyyy-mm-dd local)
  const byDay = useMemo(() => {
    const m = new Map();
    for (const s of slots) {
      const key = new Date(s.startAt).toLocaleDateString("en-CA"); // yyyy-mm-dd
      if (!m.has(key)) m.set(key, []);
      m.get(key).push(s);
    }
    for (const arr of m.values()) {
      arr.sort((a, b) => new Date(a.startAt) - new Date(b.startAt));
    }
    return m;
  }, [slots]);

  return (
    <div className="grid grid-cols-7 gap-2">
      {days.map((day, i) => {
        const key = day.toLocaleDateString("en-CA");
        const daySlots = byDay.get(key) ?? [];
        return (
          <div key={key} className="flex flex-col gap-1 min-h-[200px]">
            <div className="text-center pb-2 border-b border-gray-200">
              <div className="text-xs text-gray-500 uppercase">
                {WEEKDAY_LABELS[i]}
              </div>
              <div className="text-sm font-semibold text-gray-900">
                {day.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" })}
              </div>
            </div>
            <div className="flex flex-col gap-1">
              {daySlots.length === 0 ? (
                <div className="text-xs text-gray-400 text-center py-2">—</div>
              ) : (
                daySlots.map((s) => (
                  <AgendaSlotCell key={s.id} slot={s} onClick={onSlotClick} />
                ))
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export { startOfWeek };
